var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-item with-background"},[_c('b-container',[_c('b-row',[_c('b-col',[_c('Item',{attrs:{"car":_vm.car,"auction":_vm.auction}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }